var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayStoreIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 35,
    viewBox: "0 0 32 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6447 16.1036L24.3201 12.4562L19.1191 17.4841L23.8725 22.0798L30.6447 18.1699C30.8258 18.0653 30.9762 17.9148 31.0808 17.7337C31.1853 17.5525 31.2403 17.347 31.2403 17.1379C31.2403 16.9287 31.1853 16.7232 31.0808 16.5421C30.9762 16.3609 30.8258 16.2105 30.6447 16.1058V16.1036Z",
    fill: "#FFD109"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2473 11.8332L16.2866 7.81639L1.03418 0L18.2613 16.6527L23.2473 11.8332Z",
    fill: "#06EF79"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.28662 34.719L16.313 26.4417L22.7985 22.6972L18.2613 18.311L1.28662 34.719Z",
    fill: "#F93646"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0165393 0.673706L0 34.3055L17.4047 17.4819L0.0165393 0.673706Z",
    fill: "#05D5FB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStoreIcon);
export default __webpack_public_path__ + "static/media/play-store-icon.70670e8900fcd928aa1748e6f91e85c6.svg";
export { ForwardRef as ReactComponent };